import React, { useEffect, useState } from 'react'
import {
  Table, Button, Tooltip, Tag, Badge, PageHeader, Divider, Row, Col, message, Spin
} from 'antd'

import { PlusOutlined, EditOutlined } from '@ant-design/icons'

import { fetch } from '../../utils/fetch'

import EmailModal from '../component/EmailModal'

import EmailFilter from './component/EmailFilter'

const { Column } = Table

const Email = () => {
  const [emailList, setEmailList] = useState([])
  const [editItem, setEditItem] = useState(null)
  const [visible, setVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const getDataEmail = (query) => {
    setIsLoading(true)
    fetch({
      url: '/management/email',
      query,
    }).then((res) => {
      if (res.data?.success) {
        setEmailList(res.data?.data)
      } else {
        message.error(res.message)
      }
      setIsLoading(false)
    })
  }

  const onSuccess = () => {
    setVisible(false)
    setEditItem(null)
    getDataEmail()
  }

  const onSearch = (query) => {
    getDataEmail(query)
  }

  const onCancel = () => {
    setVisible(false)
    setEditItem(null)
  }

  useEffect(() => {
    getDataEmail()
  }, [])

  return (
    <>
      <Spin spinning={isLoading} tip="Loading..."></Spin>
      <EmailModal
        visible={visible}
        onSuccess={onSuccess}
        onCancel={onCancel}
        editItem={editItem}
      />
      <PageHeader
        ghost={false}
        title="Email"
        extra={(
          <Button type="primary" icon={<PlusOutlined />} onClick={() => { setEditItem(null); setVisible(true) }}>New</Button>
        )}
      >
        <Row gutter={24}>
          <Col xs={24} md={24}>
            <EmailFilter onSearch={onSearch} />
          </Col>
        </Row>
        <Divider />
        <Table dataSource={emailList} size="small">
          <Column title="Email" dataIndex="email" key="email" width={200} />
          <Column title="Site" dataIndex="siteCode" key="siteCode" width={50} align="center" />
          <Column title="Subject" dataIndex="subjectDescr" key="subjectDescr"
            align="center"
            width={250}
            render={(text) => (
              <>
                {
                  text?.map((val) => <Tag key={`tag-${val}`}>{val}</Tag>)
                }
              </>
            )}
          />
          <Column
            align="center"
            title="Status"
            dataIndex="isActive"
            key="isActive"
            width={100}
            render={(status) => (
              status ? <Badge status="success" /> : <Badge status="error" />
            )}
          />
          <Column
            align="center"
            title="Action"
            dataIndex="action"
            key="action"
            width={100}
            render={(text, record) => (
              <Tooltip title="Edit">
                <Button type="secondary" shape="circle" icon={<EditOutlined />} onClick={() => { setEditItem(record); setVisible(true) }} />
              </Tooltip>
            )}
          />
        </Table>
      </PageHeader>
    </>
  )
}

export default Email
